module.exports = __webpack_public_path__ + "img/ip3.e9043226.png";